import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Homepage from './components/Homepage';
import CalendarPage from './components/CalendarPage';
import Careers from './components/Careers';
import WhyTopTier from './components/WhyTopTier';
import './styles/App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/why-us" element={<WhyTopTier />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/app" element={<CalendarPage />} />
        {/* Redirect /login to /app since CalendarPage handles login state */}
        <Route path="/login" element={<Navigate to="/app" replace />} />
        {/* Catch all - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
